import { Lang } from '../../constants'

export const getCommonViewportProperties = (): Record<
  string,
  string | number
> => {
  if (typeof window === 'undefined') return {}

  return {
    lang: window.location.href.includes('/es/') ? Lang.ES : Lang.EN,
    viewport_width: window.screen.width,
    viewport_height: window.screen.height,
    viewport_size: `${window.screen.width}x${window.screen.height}`,
  }
}
